import React, { memo } from 'react';
import styles from './SoftTag.module.less';

export default memo(({ data = {} }) => {
  return (
    <div className={styles.tag}>
      <span>{data.labelName}</span>
    </div>
  );
});
